/**
 * abstract class variable constructor type variable example, because
 * i'm going to forget how this works and it may be useful idk

  interface Foo<T> {
    foo: T
  }

  abstract class AbstractFoo<T> implements Foo<T> {
    private foo;

    constructor (foo: T) {
      this.foo = foo;
    }

    // etc.
  }
 */
interface AuthClientType {
  init(): void;
  login(): void;
  logout(): void;
  handleRedirect(): void;
  readonly token: string | null;
}

abstract class AuthClient<Opts> implements AuthClientType {
  protected clientOptions;
  // Is the client initialized and able to run commands?
  // used to allow syncing multiple clients, so they are all available before
  // attempting to authenticate, or log out
  protected started: boolean;
  // is the client currently authenticated? Mainly to know which client
  // to call logout() for.
  protected authenticated: boolean;

  constructor(clientOptions: Opts) {
    this.clientOptions = clientOptions;
    this.started = false;
    this.authenticated = false;
  }

  abstract init(): void;
  abstract login(): void;
  abstract logout(): void;
  abstract handleRedirect(): void;
  abstract get token(): string | null;
}

export { AuthClient, type AuthClientType };
